import { z } from 'zod';
import { EmptyValidationMessage, FormFieldSchema, mapTextField } from '@ninja/utilities';
import { CommonRegex } from '../../../../../common';
import { useAppPlatformContextOptions } from '../../../../../contexts/app';
import { prepareFieldError } from '../../../members/members-form/helpers/add-field-error';
import { DocumentsForm } from '../types';

const field = 'emiratesId';

export const useEmiratesIdField = () => {
	const { translate: t } = useAppPlatformContextOptions();
	const getField = (memberId: string, disableEmirateId?: boolean): FormFieldSchema<DocumentsForm> =>
		mapTextField({
			field: `${memberId}.${field}`,
			inputMode: 'numeric',
			label: t('documents:fields.emirates-id.label'),
			suffix: '784 -',
			placeholder: '1990 - 1234567 - 8',
			directionForInput: 'ltr',
			placeholderDir: 'ltr',
			mask: '9999 - 9999999 - 9',
			disabled: disableEmirateId,
			onPaste: (value: string) => {
				const pastedValue = value.replace(/-|\s/g, '');
				const finalValue = pastedValue.startsWith('784') ? pastedValue.substring(3) : pastedValue;

				return finalValue;
			},
		});

	const getValidation = () => z.string({ required_error: EmptyValidationMessage });
	const validate = (
		value: string | undefined,
		emiratesIdUseCount: number,
		addFieldError: ReturnType<typeof prepareFieldError>
	) => {
		if (!value) {
			addFieldError({ field, message: EmptyValidationMessage });

			return;
		}

		if (!CommonRegex.emiratesId.test(value)) {
			addFieldError({ field, message: t('documents:fields.emirates-id.validation.regex') });
		}

		if (emiratesIdUseCount > 1) {
			addFieldError({ field, message: t('documents:fields.emirates-id.validation.unique') });
		}
	};

	return {
		getField,
		getValidation,
		validate,
	};
};
